/**
 * CLIENT BRANDING CONFIGURATION
 * 
 * Yahan aap apne Client URLs (Domain/Subdomain) ke hisab se Title, Favicon aur Apple-Touch-Icon
 * add, edit ya update kar sakte hain.
 */
export const BRANDING_CONFIG = {
  // 1. DEFAULT BRANDING: Agar URL me koi match na mile to ye load hoga.
  default: {
    title: "Client",
    appleTouchIcon: "%PUBLIC_URL%/eduprohub.ico",
    favicon: "%PUBLIC_URL%/eduprohub.ico",
  },
  //   default: {
  //   title: "Client",
  //   appleTouchIcon: "%PUBLIC_URL%/logo192.png",
  //   favicon: "%PUBLIC_URL%/favicon.ico",
  // },
  //   default: {
  //   title: "Client",
  //   appleTouchIcon: "%PUBLIC_URL%/digparikshakImage.png",
  //   favicon: "%PUBLIC_URL%/digparikshakImage.png",
  // },
  // default:{
  //   title: "Orlando - Client Portal",
  //     appleTouchIcon: "%PUBLIC_URL%/orlandoImage.jpg", // Aap iski jagah custom image path de sakte hain (e.g. "/orlando-logo.png")
  //     favicon: "%PUBLIC_URL%/orlandoImage.jpg",
  // },

  // 2. DOMAIN / URL BASED BRANDING: Client ke URL (Domain/Subdomain) ke hisab se dynamic settings
  domains: [
    {
      // URL 1: https://client.orlando.co.in/
      domainKeyword: "client.orlando.co.in",
      title: "Orlando - Client Portal",
      appleTouchIcon: "%PUBLIC_URL%/orlandoImage.jpg", // Aap iski jagah custom image path de sakte hain (e.g. "/orlando-logo.png")
      favicon: "%PUBLIC_URL%/orlandoImage.jpg",
    },
    {
      // URL 2: https://allen-ibt-client.eduprohub.in/
      domainKeyword: "allen-ibt-client.eduprohub.in",
      title: "Allen - Client Portal",
      appleTouchIcon: "%PUBLIC_URL%/eduprohub.ico", // Aap iski jagah custom image path de sakte hain (e.g. "/allen-logo.png")
      favicon: "%PUBLIC_URL%/eduprohub.ico",
    },
    {
      // URL 3: https://client.digiparikshak.co.in/
      domainKeyword: "client.digiparikshak.co.in",
      title: "DigiParikshak - Client Portal",
      appleTouchIcon: "%PUBLIC_URL%/digparikshakImage.png", // Aap iski jagah custom image path de sakte hain (e.g. "/digiparikshak-logo.png")
      favicon: "%PUBLIC_URL%/digparikshakImage.png",
    },

    /*
    // Naya Client Domain add karne ke liye niche wale block ko copy-paste karein:
    {
      domainKeyword: "newclient.com",
      title: "New Client Title",
      appleTouchIcon: "/newclient-logo.png",
      favicon: "/newclient-favicon.ico",
    },
    */
  ],

  // 3. ROUTE-BASED BRANDING (Optional): Agar URL path ke basis par bhi change karna ho
  routes: [
    /*
    {
      pathKeyword: "/exam",
      title: "Exam Portal",
      appleTouchIcon: "%PUBLIC_URL%/logo192.png",
      favicon: "%PUBLIC_URL%/favicon.ico",
    },
    */
  ],
};

/**
 * Helper function jo window.location (Domain & Path) ke basis par Head tags update karti hai
 */
export const updateBranding = (
  pathname = window.location.pathname,
  hostname = window.location.hostname
) => {
  try {
    const publicUrl = process.env.PUBLIC_URL || "";

    // 1. Domain Match Check Karein
    const matchedDomain = BRANDING_CONFIG.domains?.find((d) =>
      hostname.toLowerCase().includes(d.domainKeyword.toLowerCase())
    );

    // 2. Path/Route Match Check Karein
    const matchedRoute = BRANDING_CONFIG.routes?.find((r) =>
      pathname.toLowerCase().includes(r.pathKeyword.toLowerCase())
    );

    // Dynamic configuration select karein (Domain Match -> Route Match -> Default)
    const activeConfig = matchedDomain || matchedRoute || BRANDING_CONFIG.default;

    // A. Title Update Karein
    if (activeConfig.title) {
      document.title = activeConfig.title;
    }

    // B. Apple Touch Icon Link Tag Update Karein
    if (activeConfig.appleTouchIcon) {
      let appleIconTag = document.querySelector("link[rel='apple-touch-icon']");
      if (!appleIconTag) {
        appleIconTag = document.createElement("link");
        appleIconTag.rel = "apple-touch-icon";
        document.head.appendChild(appleIconTag);
      }
      appleIconTag.href = activeConfig.appleTouchIcon.replace("%PUBLIC_URL%", publicUrl);
    }

    // C. Favicon Link Tag Update Karein
    if (activeConfig.favicon) {
      let faviconTag = document.querySelector("link[rel='icon']");
      if (!faviconTag) {
        faviconTag = document.createElement("link");
        faviconTag.rel = "icon";
        document.head.appendChild(faviconTag);
      }
      faviconTag.href = activeConfig.favicon.replace("%PUBLIC_URL%", publicUrl);
    }

    // D. Open Graph (og:title & og:image) Meta Tags Update Karein (WhatsApp / Social Link Sharing ke liye)
    const iconPath = (activeConfig.favicon || activeConfig.appleTouchIcon || "").replace("%PUBLIC_URL%", publicUrl);
    const fullImageUrl = iconPath.startsWith("http") ? iconPath : `${window.location.origin}${iconPath}`;

    let ogTitleTag = document.querySelector("meta[property='og:title']");
    if (!ogTitleTag) {
      ogTitleTag = document.createElement("meta");
      ogTitleTag.setAttribute("property", "og:title");
      document.head.appendChild(ogTitleTag);
    }
    ogTitleTag.content = activeConfig.title || "Client";

    let ogImageTag = document.querySelector("meta[property='og:image']");
    if (!ogImageTag) {
      ogImageTag = document.createElement("meta");
      ogImageTag.setAttribute("property", "og:image");
      document.head.appendChild(ogImageTag);
    }
    ogImageTag.content = fullImageUrl;
  } catch (error) {
    console.error("Error updating branding:", error);
  }
};
